import { render, staticRenderFns } from "./TransferIcon.vue?vue&type=template&id=6b405294&"
import script from "./TransferIcon.vue?vue&type=script&lang=ts&"
export * from "./TransferIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports